import { Link } from "react-router-dom";

import Page from "../components/common/page";
import { NOT_FOUND } from "../data/about";

// Reuses the page-title and body-paragraph pattern from About.
const Notfound = () => (
	<Page page="404" className="wrap page">
		<div className="kicker">404</div>
		<h1 className="h-about" style={{ marginTop: "18px" }}>
			{NOT_FOUND.title}
		</h1>
		{NOT_FOUND.paragraphs.map((paragraph, index) => (
			<p
				key={paragraph.slice(0, 24)}
				className="p-about"
				style={index === 0 ? { marginTop: "32px" } : undefined}
			>
				{paragraph}
			</p>
		))}
		<div style={{ marginTop: "clamp(32px, 4vw, 44px)" }}>
			<Link to="/" className="link-mono-strong">
				Back to the start
			</Link>
		</div>
	</Page>
);

export default Notfound;
